import React from 'react';
import Popup from '../../Popup';
import { HighSchoolVerifiedRulesLink, VerifiedRulesLink } from '../../Links';
import { minimumVerifiedParticipants, ratingTypes } from '../../../utils/constants';

class VerificationApplicationPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { data, submittingApplication, showLoader, style, onCloseClick, onCtaClick } = this.props;

        return (
            <Popup
                className="popup-sm"
                onCloseClick={(ev) => {
                    if (!submittingApplication) {
                        onCloseClick(ev);
                    }
                }}
                config={{
                    fullScreen: false,
                    noPadding: true,
                    style,
                    scrollable: true,
                }}
            >
                <div className="popup-section p24 pt0 pb0">
                    <h5 className="text-dark mb0">{data.title}</h5>
                    {data.subTitle && (
                        <h5 className="text-gray mb0 mt8">{data.subTitle}</h5>
                    )}
                </div>
                <div className="popup-section p24 mb32 text-dark">
                    {data.description && (
                        <p>{data.description}</p>
                    )}
                    {data.bulletList}
                    {data.description2 && (
                        <p>{data.description2}</p>
                    )}
                    {data.bulletList2}
                    {data.link}
                    <div className="mt24">
                        <div className="row">
                            {data.cancelText && (
                                <div className={(data.cancelText && data.ctaText) ? 'col-6' : 'col-12'}>
                                    <button
                                        type="button"
                                        className="btn btn-default btn-default text-uppercase btn-block"
                                        onClick={onCloseClick}
                                        disabled={this.state.applicationSubmitting}
                                    >
                                        {data.cancelText}
                                    </button>
                                </div>
                            )}
                            {data.ctaText && (
                                <div className={(data.cancelText && data.ctaText) ? 'col-6' : 'col-12'}>
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-default text-uppercase btn-block"
                                        onClick={onCtaClick}
                                        disabled={submittingApplication}
                                    >
                                        {submittingApplication && showLoader && (<i className="mr8 fas fa-circle-notch fa-spin" />)}
                                        {submittingApplication ? data.ctaTextSubmitting : data.ctaText}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }
}

export default VerificationApplicationPopUp;

export const titles = {
    POST_VERIFIED_RESULTS: {
        title: 'You are Posting a Verified Result',
        description: `In order to post Verified results that count towards players' Verified ${ratingTypes.tennis}, you must agree to the following:`,
        bulletList:
    <ul>
        <li>I have the authority to post scores on behalf of my high school player.</li>
        <li>Scores must be from an official HS match from our official HS tennis schedule.</li>
        <li>No practice, challenge or unofficial matches will be posted as Verified.</li>
        <li>{ratingTypes.tennis} reserves the right to exclude any match scores not complying with the rules.</li>
        <li>{ratingTypes.tennis} reserves the right to revoke access to any high school not following the terms & conditions.</li>
    </ul>,
        link: <HighSchoolVerifiedRulesLink target="_blank">Learn more</HighSchoolVerifiedRulesLink>,
        cancelText: 'Cancel',
        ctaText: 'I Agree',
        ctaTextSubmitting: 'I Agree',
    },
    VERIFIED_HS_CLUB_APPLICTAION_EVENT_FLOW: {
        title: 'You’re Running a Verified Event',
        description: 'In order to post Verified results that count towards players\' Verified UTR Rating, you must agree to the following:',
        bulletList:
    <ul>
        <li>I have the authority to post scores on behalf of my high school player.</li>
        <li>Scores must be from an official HS match from our official HS tennis schedule.</li>
        <li>No practice, challenge or unofficial matches will be posted as Verified.</li>
        <li>UTR Sports reserves the right to exclude any match scores not complying with the rules.</li>
        <li>UTR Sports reserves the right to revoke access to any high school not following the terms & conditions.</li>
    </ul>,
        link: <HighSchoolVerifiedRulesLink target="_blank">Learn more</HighSchoolVerifiedRulesLink>,
        cancelText: 'Cancel',
        ctaText: 'I Agree',
        ctaTextSubmitting: 'I Agree',
    },
    VERIFIED_CLUB_APPLICATION_EVENT_FLOW: {
        title: 'You’re running a Verified Event!',
        subTitle: 'Apply to become a Verified Organizer.',
        description: 'To become a Verified Organizer, you must be',
        description2: 'Each Verified Event must have:',
        bulletList:
    <ul>
        <li>In good standing with UTR Sports (i.e. not suspended)</li>
        <li>At least 18 years old and no longer in high school</li>
        <li>Associated with tennis in one of the following ways: a teaching pro, a tennis facility manager, college or high school tennis coach, a member of USPTA or PTR, or you have experience as a sanctioned tournament director</li>
    </ul>,
        bulletList2:
    <ul>
        <li>Clear Scheduling/Registration</li>
        <li>Minimum of {`${minimumVerifiedParticipants}`} participants</li>
        <li>Allowed scoring formats: 2 of 3 regular sets, 2 of 3 fast 4 sets, 8 game pro set, or regular single set</li>
        <li>An Event Official designated to be responsible & accountable for all scores reported and submitted.</li>
    </ul>,
        link: <VerifiedRulesLink target="_blank">See all requirements</VerifiedRulesLink>,
        cancelText: 'No, Thanks',
        ctaText: 'Apply',
        ctaTextSubmitting: 'Applying',
    },
    VERIFIED_EVENT_APPLICATION: {
        title: 'You’re running a Verified Event!',
        subTitle: 'Please follow the Verified Event Rules',
        description: 'Each Verified Event must have:',
        bulletList:
    <ul>
        <li>Clear Scheduling/Registration</li>
        <li>Minimum of {`${minimumVerifiedParticipants}`} participants</li>
        <li>Allowed scoring formats: 2 of 3 regular sets, 2 of 3 fast 4 sets, 8 game pro set, or regular single set</li>
        <li>An Event Official designated to be responsible & accountable for all scores reported and submitted.</li>
    </ul>,
        link: <VerifiedRulesLink target="_blank">See all requirements</VerifiedRulesLink>,
        cancelText: 'Got it',
    },
    VERIFIED_CLUB_APPLICTAION_EVENT_FLOW_FOR_PICKLEBALL: {
        title: 'You’re running a Verified Event!',
        subTitle: 'Apply to become a Verified Organizer.',
        description: 'To become a Verified Organizer, you must be',
        description2: 'Each Verified Event must have:',
        bulletList:
    <ul>
        <li>In good standing with UTR Sports (i.e. not suspended)</li>
        <li>At least 18 years old and no longer in high school</li>
        <li>Associated with tennis in one of the following ways: a teaching pro, a tennis facility manager, college or high school tennis coach, a member of USPTA or PTR, or you have experience as a sanctioned tournament director</li>
    </ul>,
        bulletList2:
    <ul>
        <li>Clear Scheduling/Registration</li>
        <li>Minimum of {`${minimumVerifiedParticipants}`} participants</li>
        <li>An Event Official designated to be responsible & accountable for all scores reported and submitted.</li>
    </ul>,
        link: <VerifiedRulesLink target="_blank">See all requirements</VerifiedRulesLink>,
        cancelText: 'No, Thanks',
        ctaText: 'Apply',
        ctaTextSubmitting: 'Applying',
    },
    VERIFIED_EVENT_APPLICATION_FOR_PICKLEBALL: {
        title: 'You’re running a Verified Event!',
        subTitle: 'Please follow the Verified Event Rules',
        description: 'Each Verified Event must have:',
        bulletList:
    <ul>
        <li>Clear Scheduling/Registration</li>
        <li>Minimum of {`${minimumVerifiedParticipants}`} participants</li>
        <li>An Event Official designated to be responsible & accountable for all scores reported and submitted.</li>
    </ul>,
        link: <VerifiedRulesLink target="_blank">See all requirements</VerifiedRulesLink>,
        cancelText: 'Got it',
    },
};
